<svg class="logo" viewBox="0 0 1058.36 587.48" xmlns="http://www.w3.org/2000/svg" role="img"
    aria-label="Code Clairvoyance animated logo">

    <!-- Generator: Adobe Illustrator 30.2.1, SVG Export Plug-In . SVG Version: 2.1.1 Build 1)  -->
    <defs>
        <style>
            .st0 {
                fill: url(#linear-gradient2);
            }

            .st1 {
                fill: url(#linear-gradient1);
            }

            .st2 {
                fill: url(#linear-gradient9);
            }

            .st3 {
                fill: url(#linear-gradient8);
            }

            .st4 {
                fill: url(#radial-gradient);
            }

            .st5 {
                fill: url(#linear-gradient7);
            }

            .st6 {
                fill: url(#linear-gradient4);
            }

            .st7 {
                fill: url(#linear-gradient5);
            }

            .st8 {
                fill: url(#linear-gradient3);
            }

            .st9 {
                fill: url(#linear-gradient6);
            }

            .st10 {
                fill: url(#linear-gradient);
            }
        </style>
        <linearGradient id="linear-gradient" x1="260.61" y1="495.58" x2="539.43" y2="194.98"
            gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#0e186d" />
            <stop offset=".07" stop-color="#111c71" />
            <stop offset=".16" stop-color="#1a2b7d" />
            <stop offset=".25" stop-color="#284292" />
            <stop offset=".35" stop-color="#3d63ae" />
            <stop offset=".36" stop-color="#4068b2" />
            <stop offset=".39" stop-color="#3a5faa" />
            <stop offset=".5" stop-color="#27408f" />
            <stop offset=".6" stop-color="#192a7c" />
            <stop offset=".71" stop-color="#101c70" />
            <stop offset=".8" stop-color="#0e186d" />
            <stop offset=".82" stop-color="#3e468a" />
            <stop offset=".86" stop-color="#787dad" />
            <stop offset=".89" stop-color="#a8acca" />
            <stop offset=".92" stop-color="#ced0e1" />
            <stop offset=".95" stop-color="#e8e9f1" />
            <stop offset=".98" stop-color="#f9f9fb" />
            <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient id="linear-gradient1" x1="282.86" y1="483.76" x2="546.2" y2="199.84"
            gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#1336d2" />
            <stop offset=".4" stop-color="#3d86ff" />
            <stop offset=".75" stop-color="#1b3db6" />
            <stop offset=".78" stop-color="#2f4ebc" />
            <stop offset=".84" stop-color="#637acd" />
            <stop offset=".93" stop-color="#b5c0e7" />
            <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient id="linear-gradient2" x1="605.9" y1="588.27" x2="915.98" y2="253.97"
            gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#4068b2" />
            <stop offset=".4" stop-color="#2b338e" />
            <stop offset="1" stop-color="#0e186d" />
        </linearGradient>
        <linearGradient id="linear-gradient3" x1="653.82" y1="542.31" x2="903.09" y2="273.56"
            gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#86c0ff" />
            <stop offset=".4" stop-color="#3d86ff" />
            <stop offset="1" stop-color="#1336d2" />
        </linearGradient>
        <linearGradient id="linear-gradient4" x1="504.3" y1="432.85" x2="768.34" y2="148.18"
            gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#fff" />
            <stop offset=".11" stop-color="#1b3db6" />
            <stop offset=".67" stop-color="#3d86ff" />
            <stop offset="1" stop-color="#1336d2" />
        </linearGradient>
        <linearGradient id="linear-gradient5" x1="512.35" y1="437.98" x2="790.75" y2="137.82"
            gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#fff" />
            <stop offset=".17" stop-color="#1b3db6" />
            <stop offset=".61" stop-color="#2b338e" />
            <stop offset="1" stop-color="#0e186d" />
        </linearGradient>
        <linearGradient id="linear-gradient6" x1="148.48" y1="359.2" x2="397.74" y2="90.45"
            gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#1336d2" />
            <stop offset="1" stop-color="#6fe0fd" />
        </linearGradient>
        <linearGradient id="linear-gradient7" x1="135.38" y1="379.43" x2="445.88" y2="44.68"
            gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#0e186d" />
            <stop offset="1" stop-color="#3fa0fc" />
        </linearGradient>
        <radialGradient id="radial-gradient" cx="491.81" cy="389.21" [attr.fx]="eye.fx" [attr.fy]="eye.fy" r="322.07"
            gradientUnits="userSpaceOnUse">
            <stop offset=".1" stop-color="#b6bfe1" />
            <stop offset=".3" stop-color="#2e78ff" />
            <stop offset=".51" stop-color="#0e2f9b" />
            <stop offset=".64" stop-color="#071a58" />
        </radialGradient>
        <linearGradient id="linear-gradient8" x1="1242.6" y1="317.44" x2="1403.93" y2="317.44"
            gradientTransform="translate(1583.75) rotate(-180) scale(1 -1)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#88e2fe" />
            <stop offset="1" stop-color="#5741fc" />
        </linearGradient>
        <linearGradient id="linear-gradient9" x1="710.01" y1="317.04" x2="871.34" y2="317.04"
            gradientTransform="matrix(1,0,0,1,0,0)" xlink:href="#linear-gradient8" />

        <clipPath id="orbClip">
            <circle [attr.cx]="orb.cx" [attr.cy]="orb.cy" [attr.r]="orb.r"></circle>
        </clipPath>

    </defs>
    <g id="Lids" [attr.display]="showEyelids ? null : 'none'">
        <path id="LL_Bottom" class="st10"
            d="M67.85,316.8l333.55,185.9c2.16,1.02,3.6,1.57,4.45,1.89.17.06.31.11.43.16,14.22,5.79,51.72,21.06,99.89,21.06,11.94,0,24.54-.94,37.6-3.19,15.3-2.64,49.91-13.71,89.79-45.34,29.25-23.19,40.63-47.82,48.38-63.43,11.61-23.38,13.51-45.34,16.04-71.65l-.23-.38c-2.3,23.98-9.07,46.8-20.1,67.85-6.54,12.46-21.5,36.54-48.26,57.77-36.55,28.99-74.14,35.87-88.37,37.93-61.36,8.87-110.57-15.4-127.1-20.96-.24-.08,0,0-.33-.12-.7-.26-1.87-1.11-3.41-1.84L102.04,316.24" />
        <path id="LL_Top" class="st1"
            d="M697.77,340.42c-2.18,21.94-8.57,42.83-19.01,62.08-6.18,11.4-20.32,33.43-45.63,52.86-34.56,26.52-70.15,32.47-83.55,34.7-57.84,9.65-105.81-9.25-121.57-15.46-.22-.09-.49-.19-.8-.3-.66-.24-1.57-.57-3.02-1.24l-290.38-157.74-31.25,1.2,307.62,167.12c.71.34,1.32.69,1.86,1l1.54.83s0,0,0,0c.33.12.09.04.33.12,16.53,5.56,65.74,29.83,127.1,20.96,14.23-2.06,51.82-8.94,88.37-37.93,26.77-21.23,41.73-45.3,48.26-57.77,11.04-21.04,17.8-43.87,20.1-67.85h0c.08-.74.15-1.5.23-2.26l-.22-.34Z" />
        <path id="LR_Bottom" class="st0"
            d="M949.95,316.24l-304.16,165.23-28.82,12.33c-30.28,20.06-55.38,27.86-67.74,30.02-3.73.65-7.42,1.18-11.07,1.62,4.29.25,8.52.37,12.66.37,47.58,0,84.61-15.27,98.66-21.06.12-.05.26-.1.43-.16.85-.32,2.27-.86,4.4-1.89l329.41-185.9-33.76-.56Z" />
        <path id="LR_Top" class="st8"
            d="M917.39,317.04l-260.54,142.78c-5.47,6.19-11.91,12.48-19.62,18.67-10.35,8.3-20.33,15.18-29.71,20.87,11.49-3.44,20.27-6.94,25.58-9.05.12-.05.25-.09.4-.15.8-.3,2.15-.79,4.16-1.73l311.74-171.9-32.01.52Z" />
        <path id="UR_Bottom" class="st6"
            d="M634.01,146.06c-2.04-.94-3.4-1.43-4.21-1.73-.16-.06-.29-.1-.41-.15-13.44-5.3-48.9-19.27-94.45-19.27-11.29,0-23.2.86-35.55,2.92-14.47,2.42-47.19,12.54-84.9,41.48-27.66,21.22-38.41,43.76-45.74,58.04-10.98,21.4-12.77,41.49-15.17,65.56l.22.34c2.18-21.94,8.57-42.83,19.01-62.08,6.18-11.4,20.32-33.43,45.63-52.86,34.56-26.52,70.15-32.47,83.55-34.7,57.84-9.65,105.81,9.25,121.57,15.46.22.09.49.19.8.3.66.24,1.57.57,3.02,1.24l290,156.42,32.01-.52.13-.28-315.52-170.18Z" />
        <path id="UR_Top" class="st7"
            d="M650.17,130.06c-2.16-1.02-3.6-1.57-4.45-1.89-.17-.06-.31-.11-.43-.16-14.22-5.79-51.72-21.06-99.89-21.06-11.94,0-24.54.94-37.6,3.19-15.3,2.64-49.91,13.71-89.79,45.34-29.25,23.19-40.63,47.82-48.38,63.43-11.61,23.38-13.51,45.34-16.04,71.65l.23.38c2.3-23.98,9.07-46.8,20.1-67.85,6.54-12.46,21.5-36.54,48.26-57.77,36.55-28.99,74.14-35.87,88.37-37.93,61.36-8.87,110.57,15.4,127.1,20.96.24.08,0,0,.33.12.7.26,1.87,1.11,3.41,1.84l308.14,166.2,34.19.28-333.55-186.74Z" />
        <path id="UL_Bottom" class="st9"
            d="M414.34,154.27c10.35-8.3,20.33-15.18,29.71-20.87-11.49,3.44-20.27,6.94-25.58,9.05-.12.05-.25.09-.4.15-.8.3-2.15.79-4.16,1.73L102.17,316.24l31.64-.92,260.92-142.38c5.47-6.19,11.91-12.48,19.62-18.67Z" />
        <path id="UL_Top" class="st5"
            d="M434.59,138.96c30.28-20.06,55.38-27.86,67.74-30.02,3.73-.65,7.42-1.18,11.07-1.62-4.29-.25-8.52-.37-12.66-.37-47.58,0-84.61,15.27-98.66,21.06-.12.05-.26.1-.43.16-.85.32-2.27.86-4.4,1.89L67.85,316.8l33.76-.28,304.16-165.23,28.82-12.33Z" />
    </g>
    <g id="Orb">
        <circle id="Orb1" data-name="Orb" class="st4" cx="525.58" cy="317.44" r="172" />
    </g>

    <!-- SYMBOLS (hidden for eye/scan) -->
    <g id="Symbols" class="symbols" clip-path="url(#orbClip)" [class.hidden]="mode==='eye' || mode==='scan'">
        <text *ngFor="let p of particles; trackBy: trackById" class="sym" [attr.x]="p.x" [attr.y]="p.y"
            [attr.font-size]="p.size" [attr.opacity]="p.opacity" [attr.data-mode]="mode" [attr.style]="particleVars(p)">
            {{ p.text }}
        </text>
    </g>


    <g id="Brackets" [attr.display]="showBrackets ? null : 'none'">
        <path class="st3"
            d="M202.87,304.24l136.74-75.44c.51-.28,1.02-.53,1.55-.76-9.58,15.75-16.7,32.63-20.98,50.34l-70.8,39.06,70.8,39.06c4.28,17.7,11.4,34.59,20.98,50.34-.53-.24-1.04-.49-1.55-.77l-136.74-75.44c-5.41-2.99-23.05-13.53-23.05-13.53,0,0,17.64-9.87,23.05-12.86Z" />
        <path class="st2"
            d="M848.29,303.84l-136.74-75.44c-.51-.28-1.02-.53-1.55-.76,9.58,15.75,16.7,32.63,20.98,50.34l70.8,39.06-70.8,39.06c-4.28,17.7-11.4,34.59-20.98,50.34.53-.24,1.04-.49,1.55-.77l136.74-75.44c5.41-2.99,23.05-13.53,23.05-13.53,0,0-17.64-9.87-23.05-12.86Z" />
    </g>

</svg>